import { Link } from 'react-router-dom';
import TitleCard from '@/components/feature/TitleCard';
import type { MediaTitle } from '@/types';

interface SectionGridProps {
  title: string;
  subtitle?: string;
  items: MediaTitle[];
  link?: { to: string; label: string };
  tone?: 'default' | 'muted';
}

export default function SectionGrid({ title, subtitle, items, link, tone = 'default' }: SectionGridProps) {
  return (
    <section className={tone === 'muted' ? 'bg-background-100 py-12 md:py-16' : 'py-12 md:py-16'}>
      <div className="mx-auto max-w-[1280px] px-4 md:px-8">
        <div className="mb-6 flex items-end justify-between gap-4 md:mb-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="h-6 w-1.5 rounded-full bg-accent-500" />
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
            </div>
            {subtitle && <p className="mt-2 pl-4 text-sm text-foreground-500">{subtitle}</p>}
          </div>
          {link && (
            <Link
              to={link.to}
              className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
            >
              {link.label}
              <i className="ri-arrow-right-line" />
            </Link>
          )}
        </div>

        {items.length === 0 ? (
          <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-film-line text-2xl" />
            </span>
            <p className="mt-4 text-sm text-foreground-500">暂无相关影视资源，敬请期待</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
            {items.map((item) => (
              <TitleCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}